import { render } from "./FeedbackUploadScreen.vue?vue&type=template&id=21bd46b7"
import script from "./FeedbackUploadScreen.vue?vue&type=script&lang=ts"
export * from "./FeedbackUploadScreen.vue?vue&type=script&lang=ts"

import "./FeedbackUploadScreen.vue?vue&type=style&index=0&id=21bd46b7&lang=scss"
script.render = render

export default script